import { ErrorBoundary } from 'react-error-boundary';

export const withError = (Component: any) => (props: any) => {
  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <div className="my-20 w-full relative">
          <p className="text-center text-text-light text-lg">
            Não foi possível carregar o gráfico.
          </p>
        </div>
      )}
      resetKeys={[props?._chartOptions, props?.series]}
    >
      <Component {...props} />
    </ErrorBoundary>
  );
};
